import React from "react";
import PropTypes from "prop-types";

const colorMap = {
  green: {
    bg: "bg-green-50 dark:bg-green-950/40",
    text: "text-green-700 dark:text-green-400",
    change: "text-green-600 dark:text-green-500"
  },
  red: {
    bg: "bg-red-50 dark:bg-red-950/40",
    text: "text-red-700 dark:text-red-400",
    change: "text-red-600 dark:text-red-500"
  },
  orange: {
    bg: "bg-orange-50 dark:bg-orange-950/40",
    text: "text-orange-700 dark:text-orange-400",
    change: "text-orange-600 dark:text-orange-500"
  },
  blue: {
    bg: "bg-blue-50 dark:bg-blue-950/40",
    text: "text-blue-700 dark:text-blue-400",
    change: "text-blue-600 dark:text-blue-500"
  },
  gray: {
    bg: "bg-gray-100 dark:bg-gray-800/50",
    text: "text-gray-700 dark:text-gray-400",
    change: "text-gray-600 dark:text-gray-500"
  }
};

const SummaryCard = ({ title, amount, currency, change, color }) => {
  const colors = colorMap[color] || colorMap.blue;
  const displayValue =
    typeof amount === "string" ? amount : `${currency} ${Number(amount).toLocaleString("es-PE", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  return (
    <div className={`${colors.bg} rounded-2xl p-6 shadow-sm border border-gray-100 dark:border-gray-800/50 transition-colors`}>
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-2">
        {title}
      </p>
      <p className={`text-2xl md:text-3xl font-bold ${colors.text} mb-1`}>
        {displayValue}
      </p>
      {change != null && (
        <p className={`text-sm font-medium flex items-center gap-1 ${colors.change}`}>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
          +{change}% vs mes anterior
        </p>
      )}
    </div>
  );
};

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  currency: PropTypes.string.isRequired,
  change: PropTypes.number,
  color: PropTypes.oneOf(["green", "red", "orange", "blue", "gray"])
};

export { SummaryCard };
